import { createActionGroup, props } from '@ngrx/store';

export const vacancyExistsGuardActions = createActionGroup({
  source: 'Vacancy Exists Guard',
  events: { 'Can Activate': props<{ vacancyId: string }>() },
});
